// extracted by mini-css-extract-plugin
module.exports = {"steps":"questions-module--steps--108uS","background":"questions-module--background--2Mvn7"};